const ActionType = {
  CLOSE_MESSAGE: "NOTIFICATION_MESSAGE_CLOSE_MESSAGE",
  LEAD_TO_LOGIN: "NOTIFICATION_MESSAGE_LEAD_TO_LOGIN",
  OPEN_MESSAGE: "NOTIFICATION_MESSAGE_OPEN_MESSAGE",
};

export default ActionType;
